import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, VariableDataBinding } from 'editor/src/store/design/types';

const setVariableDataBindingReducer = (state: DesignState, action: PayloadAction<VariableDataBinding | undefined>) => {
  if (state.designData) {
    state.designData.variableData = action.payload;
  }
};

export default setVariableDataBindingReducer;
